export default __webpack_public_path__ + "img/92ff447c3a76d8a430d6a72ab8fe742f.png";